export default __webpack_public_path__ + "static/media/icon-coin-decentralized.65af38a2.svg";